import { useState } from "react";
import { useNavigate } from 'react-router-dom';
import { successToast, errorToast } from "../../../components/toastmessage/toastmessage";
import { handleValidation } from "./validation";
import { postInsuranceApiCall } from "./insuranceService";


const useAddInsuranceHook = (initialState) => {
    const navigate = useNavigate();
    const [insuranceState, setInsuranceState] = useState(initialState);
    const [errors, setError] = useState({});

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setInsuranceState((prevFormState) => ({
            ...prevFormState,
            [name]: value,
        }));

    }

    const handleInsuranceSubmit = async (event) => {
        event.preventDefault();
        try {
            let payload = {
                ...insuranceState,
                createdBy: JSON.parse(sessionStorage.getItem("tenantDetails"))[0]?.createdBy,
                tenantID: JSON.parse(sessionStorage.getItem("tenantDetails"))[0]?.tenantID,
                activeStatus: true 
            }
            let isValid = await handleValidation(payload);
            if (isValid?.formIsValid) {
                try {
                    await postInsuranceApiCall(payload);
                    successToast("Successfully Inserted");
                    setInsuranceState(initialState)
                } catch (err) {
                    errorToast("Something went wrong")
                }

            } else {
                let inputError = {
                    ...isValid?.errors,
                    formIsValid: isValid?.formIsValid,
                    bedInfoError: isValid?.individualInputErrors
                }
                setError(inputError)
            }
        } catch (e) {
            errorToast("Something went wrong")
        }


    }
    const handleGoBack = () => {
        navigate("/master/insurance-list")
    }

  
    return {
        insuranceState,
        errors,
        handleInputChange,
        handleInsuranceSubmit,
        handleGoBack,
        
    }


};


export default useAddInsuranceHook;
